/**
 * TWS Currency Converter — v2
 * Converts .ht-money price elements between AED / USD / EUR.
 * Live rates via open.er-api.com, cached 1h in localStorage.
 */
(function () {
  'use strict';

  var CURRENCIES = ['AED', 'USD', 'EUR'];
  var SYMBOLS    = { AED: 'Dhs.', USD: 'US$', EUR: '€' };
  var RATES_KEY  = 'twc_fx_v2';
  var PREF_KEY   = 'twc_cur_v2';

  // Fallback rates when API unavailable (AED base)
  var rates = { AED: 1, USD: 0.2723, EUR: 0.2498 };
  var active = 'AED';

  try { active = localStorage.getItem(PREF_KEY) || 'AED'; } catch (e) {}

  // ── Rate management ───────────────────────────────────────
  function getCachedRates() {
    try {
      var c = JSON.parse(localStorage.getItem(RATES_KEY) || 'null');
      if (c && c.ts && Date.now() - c.ts < 3600000 && c.data) { return c.data; }
    } catch (e) {}
    return null;
  }

  function setCachedRates(data) {
    try { localStorage.setItem(RATES_KEY, JSON.stringify({ ts: Date.now(), data: data })); } catch (e) {}
  }

  function fetchRates(cb) {
    fetch('https://open.er-api.com/v6/latest/AED')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j && j.rates && j.rates.USD) {
          rates = { AED: 1, USD: +j.rates.USD.toFixed(6), EUR: +j.rates.EUR.toFixed(6) };
          setCachedRates(rates);
        }
        cb && cb();
      })
      .catch(function () { cb && cb(); });
  }

  // ── Price parsing ─────────────────────────────────────────
  function parseAmount(text) {
    // Strip all known currency markers, keep digits/period/comma
    var s = (text || '')
      .replace(/Dhs\.?/gi, '')
      .replace(/\bAED\b|\bUSD\b|\bEUR\b/gi, '')
      .replace(/US\$|[$€£]/g, '')
      .replace(/\s/g, '');
    // Remove thousand-separator commas (e.g. 24,500 → 24500)
    s = s.replace(/,(?=\d{3}(\D|$))/g, '');
    return parseFloat(s) || 0;
  }

  function formatAmount(aed, currency) {
    var val = aed * rates[currency];
    // Watches are high-value; no decimals for foreign currencies, 2dp for AED
    var opts = currency === 'AED'
      ? { minimumFractionDigits: 2, maximumFractionDigits: 2 }
      : { minimumFractionDigits: 0, maximumFractionDigits: 0 };
    return SYMBOLS[currency] + ' ' + val.toLocaleString('en-US', opts);
  }

  // ── DOM conversion ────────────────────────────────────────
  var converting = false;

  function convertAll(currency) {
    converting = true;

    document.querySelectorAll('.ht-money').forEach(function (el) {
      // Snapshot original AED amount on first run (before any conversion)
      if (!el.hasAttribute('data-twc-aed')) {
        var amount = parseAmount(el.textContent || '');
        if (amount <= 0) return;
        el.setAttribute('data-twc-aed', String(amount));
      }

      var base = parseFloat(el.getAttribute('data-twc-aed') || '0');
      if (!base || base <= 0) return;

      var next = formatAmount(base, currency);
      // Only write if actually different — prevents MutationObserver loop
      if ((el.textContent || '').trim() !== next) {
        el.textContent = next;
      }
    });

    syncUI(currency);
    converting = false;
  }

  var FLAGS = { AED: '🇦🇪', USD: '🇺🇸', EUR: '🇪🇺' };

  function syncUI(currency) {
    // Update trigger label
    var flagEl = document.getElementById('twc-cur-flag');
    var codeEl = document.getElementById('twc-cur-code');
    if (flagEl) flagEl.textContent = FLAGS[currency] || '';
    if (codeEl) codeEl.textContent = currency;

    // Update active state on all option items
    document.querySelectorAll('[data-twc-currency]').forEach(function (el) {
      var isActive = el.getAttribute('data-twc-currency') === currency;
      el.classList.toggle('twc-cur--active', isActive);
      if (el.hasAttribute('aria-selected')) el.setAttribute('aria-selected', isActive ? 'true' : 'false');
      if (el.hasAttribute('aria-pressed')) el.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  // ── Dropdown open/close ───────────────────────────────────
  function initDropdown() {
    var wrapper = document.getElementById('twc-cur-dropdown');
    var trigger = document.getElementById('twc-cur-trigger');
    var menu    = document.getElementById('twc-cur-menu');
    if (!wrapper || !trigger || !menu) return;

    function openMenu() {
      wrapper.classList.add('twc-cur--open');
      trigger.setAttribute('aria-expanded', 'true');
    }
    function closeMenu() {
      wrapper.classList.remove('twc-cur--open');
      trigger.setAttribute('aria-expanded', 'false');
    }
    function toggleMenu() {
      wrapper.classList.contains('twc-cur--open') ? closeMenu() : openMenu();
    }

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      toggleMenu();
    });

    // Option click
    menu.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-twc-currency]');
      if (!opt) return;
      window.twcCurrency.set(opt.getAttribute('data-twc-currency'));
      closeMenu();
    });

    // Keyboard: Enter/Space on options
    menu.addEventListener('keydown', function (e) {
      var opt = e.target.closest('[data-twc-currency]');
      if (!opt) return;
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        window.twcCurrency.set(opt.getAttribute('data-twc-currency'));
        closeMenu();
        trigger.focus();
      }
    });

    // Mobile flat options
    document.querySelectorAll('.twc-cur--mobile [data-twc-currency]').forEach(function (opt) {
      opt.addEventListener('click', function () {
        window.twcCurrency.set(opt.getAttribute('data-twc-currency'));
      });
    });

    // Close on outside click
    document.addEventListener('click', function () { closeMenu(); });
    wrapper.addEventListener('click', function (e) { e.stopPropagation(); });
  }

  // ── Public API ────────────────────────────────────────────
  window.twcCurrency = {
    set: function (currency) {
      if (CURRENCIES.indexOf(currency) === -1) return;
      active = currency;
      try { localStorage.setItem(PREF_KEY, currency); } catch (e) {}
      convertAll(currency);
    },
    current: function () { return active; }
  };

  // ── Init ──────────────────────────────────────────────────
  function init() {
    initDropdown();
    syncUI(active);
    if (active !== 'AED') convertAll(active);
  }

  var cached = getCachedRates();
  if (cached) {
    rates = cached;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  } else {
    // Fetch live rates first, then init
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        fetchRates(function () { init(); });
      });
    } else {
      fetchRates(function () { init(); });
    }
  }

  // Re-apply after Shopify AJAX updates (cart, quick-buy)
  document.addEventListener('shopify:section:load', function () {
    if (!converting) convertAll(active);
  });

  // MutationObserver: re-apply when new prices are injected into the DOM
  // Guard against feedback loop with the `converting` flag
  if (window.MutationObserver) {
    var timer;
    var observer = new MutationObserver(function (mutations) {
      if (converting) return;
      // Only act if a .ht-money element was added (not just text changed by us)
      var relevant = mutations.some(function (m) {
        return Array.from(m.addedNodes).some(function (n) {
          return n.nodeType === 1 && (
            n.classList && n.classList.contains('ht-money') ||
            n.querySelector && n.querySelector('.ht-money')
          );
        });
      });
      if (!relevant) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (!converting) convertAll(active);
      }, 200);
    });

    document.addEventListener('DOMContentLoaded', function () {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }
})();
